import type { ComponentProps } from 'react'
import BrandDisambiguationResults from '@/app/(app)/tools/brand-disambiguation/components/BrandDisambiguationResults'
import type { ToolDetailProps } from './detailRegistry'

/**
 * Dashboard detail renderer for `brandDisambiguation` (Phase 3, Step 14 — last
 * Class B dashboard-reuse). This REPLACES the legacy inline
 * `brandDisambiguation` branch that lived in `ToolDetailPanel` (a 3-stat
 * severity row + flat confusion-flag list).
 *
 * REUSES the public `BrandDisambiguationResults` directly — no `variant` prop
 * is needed because, unlike the other tools, this renderer carries NO
 * public-only chrome: it is a single self-contained result card (the email
 * share / PlatformCTA / gradient marketing CTAs for this tool live on the
 * public page, outside the renderer). The platform route
 * (`/api/platform/tools/brand-disambiguation`) returns the same
 * `BrandDisambiguationResult`, so the dashboard `data` maps straight onto the
 * component — the dashboard now shows the full rich report (score + grade hero,
 * severity breakdown, the per-engine findings including the "Identified
 * correctly" positive rows, the verified-identity/ground-truth block,
 * recommendations, and the AI summary) instead of the generic panel.
 *
 * The component already supplies its own card surface, so the wrapper here is a
 * BARE `id="tool-detail-panel"` div (scroll anchor only) — wrapping it in the
 * standard `bg-card` panel would double-border the card.
 *
 * Grade comes from `data.grade` via the reused component — never recomputed
 * (the renderer's `gradeColor()` only derives a display color from the score,
 * the grade text itself reads `result.grade`). The deleted generic
 * deriveBreakdown is NOT reintroduced. Render-layer only.
 */
export function BrandDisambiguationDashboardDetail({ data }: ToolDetailProps) {
  const result = data as unknown as ComponentProps<
    typeof BrandDisambiguationResults
  >['result']
  return (
    <div id='tool-detail-panel'>
      <BrandDisambiguationResults result={result} />
    </div>
  )
}
